export default "__VITE_ASSET__ByHlin25__"